import clsx from "clsx";
import { Loading } from "src/components/loading/Loading";
import styles from "./LoadingGhost.loading.module.scss";

export namespace LoadingGhostLoading {
    export type ElementName = "LoadingGhost.Loading";
    export type ElementType = HTMLElement;
    export type Props = Loading.Props;
}

export const LoadingGhostLoading = (props: LoadingGhostLoading.Props) => {
    const { className, ...restProps } = props;

    return(
        <Loading className={clsx(styles["loading"], className)} {...restProps} />
    );
}